import type { FC } from "react"

interface Props {
  className?: string
}

const Unmute: FC<Props> = ({ className }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.625 13.1875C6.625 13.9334 6.32868 14.6488 5.80124 15.1762C5.27379 15.7037 4.55842 16 3.8125 16C3.06658 16 2.35121 15.7037 1.82376 15.1762C1.29632 14.6488 1 13.9334 1 13.1875C1 12.4416 1.29632 11.7262 1.82376 11.1988C2.35121 10.6713 3.06658 10.375 3.8125 10.375C4.55842 10.375 5.27379 10.6713 5.80124 11.1988C6.32868 11.7262 6.625 12.4416 6.625 13.1875ZM6.625 13.1875V1H16V13.1875M16 13.1875C16 13.9334 15.7037 14.6488 15.1762 15.1762C14.6488 15.7037 13.9334 16 13.1875 16C12.4416 16 11.7262 15.7037 11.1988 15.1762C10.6713 14.6488 10.375 13.9334 10.375 13.1875C10.375 12.4416 10.6713 11.7262 11.1988 11.1988C11.7262 10.6713 12.4416 10.375 13.1875 10.375C13.9334 10.375 14.6488 10.6713 15.1762 11.1988C15.7037 11.7262 16 12.4416 16 13.1875ZM6.625 4.75H16"
        stroke="#002800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Unmute
